import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'timeago', pure: false })
export class TimeagoPipe implements PipeTransform {
  transform(value: string | Date | number, ...args: any[]): string {
    if (!value) return '';
    const now = new Date().getTime();
    const then = new Date(value).getTime();
    const seconds = Math.floor(Math.abs(now - then) / 1000);
    const isFuture = now < then;
    
    const intervals: { [key: string]: number } = {
        year: 31536000, month: 2592000, week: 604800,
        day: 86400, hour: 3600, minute: 60, second: 1
    };
    
    for (const [name, secondsInUnit] of Object.entries(intervals)) {
        const amount = Math.floor(seconds / secondsInUnit);
        if (amount >= 1) {
            const label = `${amount} ${name}${amount > 1 ? 's' : ''}`;
            return isFuture ? `in ${label}` : `${label} ago`;
        }
    }
    return 'just now';
  }
}
